import { html } from 'lit/html.js';
import { classMap } from 'lit/directives/class-map.js';
import { BLANK_AVATAR_IMAGE_DECODED } from './constants.js';
import { Authentication } from './DxoUiHeader.js';

const BASE64_REGEX = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
const PATH_PREFIXES = ['/image', '/public', '/asset', '/static', '/avatar', '/src'];

/**
 * Determines if a string is a raw base64-encoded image.
 * Returns false if:
 *  - The string is shorter than 128 characters (likely too short to be an encoded image)
 *  - The string starts with a common image path prefix (e.g. /images, /public, /assets)
 *  - The string has characters that are not in the valid base64 character set
 * Returns true if:
 *  - The string is 128+ characters, does not start with a path prefix, and matches the base64 regex
 */
export function isRawBase64(value: string): boolean {
  if (value.length < 128) return false;
  if (PATH_PREFIXES.some(prefix => value.startsWith(prefix))) return false;
  return BASE64_REGEX.test(value);
}

export function getProfilePicture(authentication: Authentication) {
  if (authentication.profilePictureSrc && authentication.profilePictureSrc !== BLANK_AVATAR_IMAGE_DECODED) {
    const imageSrc = isRawBase64(authentication.profilePictureSrc) ? `data:image/png;base64,${authentication.profilePictureSrc}` : authentication.profilePictureSrc;
    return html`<img class="profile-img" src="${imageSrc}" alt="Profile Picture"/>`;
  }
  return html`<div class="profile-circle">${authentication.displayName?.charAt(0) || ''}</div>`;
}

export function getLogout(authentication: Authentication, mobile = false) {
  const classes = {
    'dropdown-button': true,
    'dropdown-button-signout': true,
    'mobile-logout': mobile,
  };
  if (typeof(authentication.logout) === 'function') {
    return html`
      <button class=${classMap(classes)} @click=${authentication.logout}>Sign Out</button>
    `
  }
  return html`<a class=${classMap(classes)} href="${authentication.logout}">Sign Out</a>`
}

export function isActiveHeaderTab(activeHeaderTab: string, tabText: string): string {
  if (activeHeaderTab && tabText.toLowerCase() === activeHeaderTab.toLowerCase()) return 'active';
  return '';
}

export function isActiveSubheaderTab(activeSubheaderTab: string, tabLabel: string): string {
  if (activeSubheaderTab && tabLabel.toLowerCase() === activeSubheaderTab.toLowerCase()) return 'active';
  return '';
}

// activeSubheaderTab and activeSubheaderDropdownLink are the currently "active" values based on the provided parameters to the component.
// subheaderTabLabel and linkText are the features of the link being checked against the active values.
export function isActiveSubheaderDropdownLink(activeSubheaderTab: string, activeSubheaderDropdownLink: string, subheaderTabLabel: string, linkText: string): string {
  const isActive = isActiveSubheaderTab(activeSubheaderTab, subheaderTabLabel) === 'active';
  const isActiveLink = activeSubheaderDropdownLink && linkText.toLowerCase() === activeSubheaderDropdownLink.toLowerCase();
  return isActive && isActiveLink ? 'active' : '';
}
